import { Tag } from "antd";
import { PreferredCommunicationMethod } from "./constants";
import { capitalize } from ".";

export const renderChannel = {
  [PreferredCommunicationMethod.EMAIL]: (
    <Tag color="blue">{capitalize(PreferredCommunicationMethod.EMAIL)}</Tag>
  ),
  [PreferredCommunicationMethod.TEXT_MESSAGE]: (
    <Tag color="purple">
      {capitalize(PreferredCommunicationMethod.TEXT_MESSAGE)}
    </Tag>
  ),
  [PreferredCommunicationMethod.BOTH]: (
    <>
      <Tag color="blue">Email</Tag>
      <Tag color="purple">SMS</Tag>
    </>
  ),
};
